export enum ObjectStatus {
  Undefined = "Undefined",
  ToBeDigitalized = "ToBeDigitalized",
  ToBeQCed = "ToBeQCed",
  ParsedAndProbbed = "ParsedAndProbbed",
  New = "New",
  Ready = "Ready",
  Offline = "Offline",
  EditingInProgress = "EditingInProgress",
  Unused = "Unused",
  Rejected = "Rejected",
  Accepted = "Accepted",
  NeedCheckOrEditing = "NeedCheckOrEditing",
  QualityCheckInProgress = "QualityCheckInProgress",
  WaitingForMEZZReference = "WaitingForMEZZReference",
  Deleted = "Deleted",
  Unmapped = "Unmapped",
  RejectedAuto = "RejectedAuto",
  ToBeNormalized = "ToBeNormalized",
  ProjectReady = "ProjectReady",
  ProjectInProgress = "ProjectInProgress",
  ProjectStandby = "ProjectStandby",
  ProjectCompleted = "ProjectCompleted",
  ProjectRejected = "ProjectRejected",
  AcceptedForBroadcast = "AcceptedForBroadcast",
  RejectedForBroadcast = "RejectedForBroadcast",
  Delivered = "Delivered",
  Broadcasted = "Broadcasted",
  MissingMetadata = "MissingMetadata",
  Disabled = "Disabled", // Not existing on API, just UI helper
}
